import React from 'react'
import { CustomButtonProps } from './types'
import * as Styled from './customButton.styled'
import { CookieName } from 'app/shared/enums'

const CustomButton: React.FunctionComponent<CustomButtonProps> = ({
  isDisabled,
  children,
  type = 'button',
  name,
  onClick,
  size,
  color,
  text,
  variant = 'thin',
  fillType = 'semi',
  style,
  id,
  href,
  className,
}) => {
  return !href ? (
    <Styled.Root
      type={type}
      onClick={onClick}
      color={color}
      name={name}
      variant={variant}
      fillType={fillType}
      disabled={isDisabled}
      style={style}
      id={id}
      href={href}
      className={className}
      size={size}
    >
      {text || children}
    </Styled.Root>
  ) : (
    <Styled.RootLink
      type={type}
      onClick={onClick}
      color={color}
      key={name}
      variant={variant}
      fillType={fillType}
      disabled={isDisabled}
      style={style}
      id={id}
      href={'/' + localStorage.getItem(CookieName.Language) + href}
      className={className}
      size={size}
    >
      {text || children}
    </Styled.RootLink>
  )
}

export default CustomButton
